import request from '@/common/js/request.js'

export function fetchrecruit (obj) {
  return request({
    url: '/recruit/apply',
    method: 'post',
    data: obj
  })
}

export function fetchpersonApply (obj) {
  return request({
    url: '/merchants/personApply',
    method: 'post',
    data: obj
  })
}

export function fetchPersonApply (obj) {
  return request({
    url: '/merchants/selectPersonApply',
    method: 'get',
    params: obj
  })
}


export function fetchbusinessApply (obj) {
  return request({
    url: '/merchants/businessApply',
    method: 'post',
    data: obj
  })
}

export function fetchBusinessApply (obj) {
  return request({
    url: '/merchants/selectBusinessApply',
    method: 'get',
    params: obj
  })
}

// 查经营类目列表
export function fetchCourseType (obj) {
  return request({
    url: '/courseType/getCourseMainType',
    method: 'get',
    params: obj
  })
}

// 登录到后台
export function loginht (obj) {
  return request({
    url: '/authLogin/selectAuthCode',
    method: 'get',
    params: obj
  })
}

// 机构类别 /orgType/getOrgTypeListForMobile
export function fetchOrgType (obj) {
  return request({
    url: '/orgType/getOrgTypeListForMobile',
    method: 'get',
    params: obj
  })
}



// WEBPACK FOOTER //
// ./src/api/recruit.js